import { styled } from 'styled-system/jsx'

const Section = styled('section', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px 22px',
    border: '1.5px solid',
    borderColor: 'quickpass.primarySoft',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const SectionHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
})

const SectionTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.2px',
  },
})

const Eyebrow = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: 'quickpass.primary',
  },
})

const PrimaryAction = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '700',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    borderRadius: 'pill',
    paddingX: '14px',
    paddingY: '7px',
    cursor: 'pointer',
    transition:
      'transform {durations.fast} {easings.appleStandard}, box-shadow {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
      boxShadow: '0 12px 28px -10px rgba(128, 84, 255, 0.5)',
    },
    _disabled: {
      opacity: '0.5',
      cursor: 'not-allowed',
      _hover: { transform: 'none', boxShadow: 'none' },
    },
  },
})

const TextButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '0',
    transition: 'color {durations.fast} {easings.appleStandard}',
    _hover: { color: 'quickpass.primary' },
  },
})

const PromptBlock = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.5',
  },
})

const OneLineTake = styled('p', {
  base: {
    fontFamily: 'display',
    fontSize: '16px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.2px',
    paddingX: '14px',
    paddingY: '12px',
    borderRadius: 'md',
    backgroundColor: 'quickpass.surfaceCool',
    borderLeft: '3px solid',
    borderColor: 'quickpass.primary',
  },
})

const ColumnsGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '14px',
    md: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },
  },
})

const Column = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
})

const ColumnHeading = styled('h3', {
  base: {
    fontFamily: 'display',
    fontSize: '13px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.1px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
})

const BulletList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
})

const Bullet = styled('li', {
  base: {
    display: 'grid',
    gridTemplateColumns: '20px 1fr',
    gap: '8px',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.ink',
    lineHeight: '1.45',
  },
})

const BulletGlyph = styled('span', {
  base: {
    fontSize: '14px',
    lineHeight: '1.3',
  },
})

const QuestionsBlock = styled('div', {
  base: {
    paddingTop: '6px',
    borderTop: '1px solid',
    borderColor: '#F0EDFA',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
})

const Footer = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '8px',
    borderTop: '1px solid',
    borderColor: '#F0EDFA',
  },
})

const FooterStamp = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

const ErrorBanner = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.warmth',
    fontWeight: '600',
  },
})

const LoadingShimmer = styled('div', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

export {
  Section,
  SectionHeader,
  SectionTitle,
  Eyebrow,
  PrimaryAction,
  TextButton,
  PromptBlock,
  OneLineTake,
  ColumnsGrid,
  Column,
  ColumnHeading,
  BulletList,
  Bullet,
  BulletGlyph,
  QuestionsBlock,
  Footer,
  FooterStamp,
  ErrorBanner,
  LoadingShimmer,
}
